import React, { useState, useEffect, useContext } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialButton from "../../../components/MaterialButton";
import colors from "../../../assest/theme/base/colors";
import { Box, Dialog } from "@mui/material";
import DynamicTableProps from "../../Utils/DynamicTableProps";
import AddUserMaster from "./usermasteradd";
import ConfirmDialog from "../../Utils/ConfirmDialog";
import {
  Getalluserdetail,
  Deleteuser,
  getByTLUserdetail,
} from "../UserMaster/mutation";
import { fetchAll, deleteItem, fetchById, FetchDataGet } from "../../../BaseUrl";
import MessagePopup from "../../Utils/MessagePopup";
import LoadingSpinner from "../../loader/loadercomp";
import ExportDialog from "../../Utils/ExportDialog";
import AccessComponent from "../../Utils/AccessComponent";
import { UserContext } from "../../usercontext/usercontext";

function UserMaster() {
  const { user, isuser } = useContext(UserContext);
  const [open, setOpen] = useState(false);
  const [view, setview] = useState(false);
  const [searchdata, setsearchdata] = useState("");
  const [sortedvalue, setsortedvalue] = useState("");
  const [editeddata, setEditeddata] = useState([]);
  const [editedtrue, setEditedtrue] = useState(false);
  const [dialogData, setDialogData] = useState({
    title: "",
    content: "",
    onConfirm: () => {},
  });
  const [popup, setPopup] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [userlist, setuserlist] = useState([]);
  const [Loader, setLoader] = useState(false);
  const [serverPage, setServerPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [prevSearch, setPrevSearch] = useState("");

  const [countryState, setCountryState] = useState({
    countries: [],
    countryCodes: [],
    states: [],
    selectedCountryCode: null,
    selectedCountry: null,
    selectedState: null,
  });
  const [dialogOpen, setDialogOpen] = useState(false);

  const [openExport, setOpenExport] = useState(false);

  const columns = [
    { label: "User Name", field: "username", width: "150px" },
    { label: "Language", field: "language", width: "130px" },
    { label: "Gender", field: "gender", width: "130px" },
    { label: "Role", field: "roleName", width: "130px" },
    { label: "Mail", field: "mailAddress", width: "200px" },
    { label: "Status", field: "status", width: "150px" },
    { label: "Actions", field: "actions", width: "150px" },
  ];

  const validIndustryData = Array.isArray(userlist) ? userlist : [];

  const sortedData = [...validIndustryData].sort((a, b) => {
    const sortOption = sortedvalue?.value || "descending"; // default to descending
    switch (sortOption) {
      case "ascending":
        return new Date(a.createdAt) - new Date(b.createdAt);
      case "descending":
        return new Date(b.createdAt) - new Date(a.createdAt);
      default:
        return validIndustryData; // default to descending
    }
  });

  const formatDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const exportData = sortedData.map((item) => ({
    id: item.id,
    username: item.username || "N/A",
    firstName: item.firstName || "N/A",
    lastName: item.lastName || "N/A",
    gender: item.gender || "N/A",
    language: item.language || "N/A",
    mailAddress: item.mailAddress || "N/A",
    address: item.address || "N/A",
    countryCode: item.countryCode || "N/A",
    contactNumber: item.contactNumber || "N/A",
    primaryCountryCode: item.primaryCountryCode || "N/A",
    primaryContactNumber: item.primaryContactNumber || "N/A",
    dateOfBirth: formatDate(item.dateOfBirth),
    roleName: item.role?.roleName || "N/A",
    teamLeaderUsername: item.teamLeader?.username || "N/A",
    clientHandling:
      item.clientHandling && item.clientHandling.length > 0
        ? item.clientHandling.map((c) => c.clientName).join(", ")
        : "N/A",
    status: item.status === true ? "Active" : "Inactive" || "N/A",
    dateOfJoining: item.dateOfJoining || "N/A",
    dateOfRelieving: item.dateOfRelieving || "N/A",
  }));

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      let currentPage = serverPage;
      if (searchdata !== prevSearch) {
        setServerPage(1);
        currentPage = 1;
        setPrevSearch(searchdata);
      }
      getALluserdetail(currentPage, searchdata);
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchdata, serverPage]);

  useEffect(() => {
    if (!open) {
      getALluserdetail(serverPage, searchdata);
    }
  }, [open]);

  const exportClose = () => {
    setOpenExport(false);
  };

  const formClose = () => {
    setOpen(false);
    getALluserdetail(serverPage, searchdata);
    setview(false);
  };
  const addRole = () => {
    setOpen(true);
  };

  const onView = (id) => {
    let data = userlist.filter((x) => x.id === id);
    setEditeddata(data);
    setEditedtrue(true);
    setOpen(true);
    setview(true);
  };

  const onEdit = (id) => {
    let data = userlist.filter((x) => x.id === id);
    setEditeddata(data);
    setEditedtrue(true);
    setOpen(true);
  };

  const deletelist = (id) => {
    handleOpenDialog();
    setDialogData({
      title: "Are you sure you want to delete this records ?",
      content: `If you delete the field you can’t recover it`,
      onConfirm: () => deleteconfirm(id),
      onClose: () => deletecancel(),
    });
  };

  const deleteconfirm = async (id) => {
    try {
      const variables = {
        input: {
          id: id,
        },
      };
      const response = await deleteItem(Deleteuser, variables);
      if (response.deleteCustomUser.success == true) {
        setPopup({
          open: true,
          message: response.deleteCustomUser.message,
          severity: "success",
        });
        deletecancel();
        getALluserdetail(serverPage, searchdata);
      } else {
        setPopup({
          open: true,
          message: response.deleteCustomUser.message,
          severity: "error",
        });
        deletecancel();
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const deletecancel = () => {
    setDialogOpen(false);
    setDialogData({
      ...dialogData,
      title: "",
      content: "",
      onConfirm: () => {},
    });
  };

  //delete api call
  const deleteRole = async (id) => {
    handleCloseDialog();
  };
  //open and close dialog for confirmation
  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const getALluserdetail = async (page = serverPage, search = searchdata) => {
    setLoader(true);
    const role = user?.roleName;
    const userId = parseInt(isuser?.userid);
    
    try {
      if ((role === "Team Lead" || role === "Team Leader" || role === "Recruiters") && userId) {
        const variables = { id: userId };
        const response = await fetchById(getByTLUserdetail, variables);
        if (response?.getTeamLeaderUserById?.success === true) {
          const data = response?.getTeamLeaderUserById.data;
          setuserlist(data);
          setTotalCount(data.length);
        } else {
          setuserlist([]);
          setTotalCount(0);
        }
      } else {
        const variables = {
          search: search,
          page: page,
          pageSize: 10,
        };
        const response = await FetchDataGet(Getalluserdetail, variables);
        if (response?.getAllCustomUserDetails?.success === true) {
          setuserlist(response?.getAllCustomUserDetails.data);
          setTotalCount(response?.getAllCustomUserDetails?.totalCount || 0);
        } else {
          setuserlist([]);
          setTotalCount(0);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  return (
    <DashboardLayout
      setOpenExport={setOpenExport}
      searchdata={searchdata}
      setsearchdata={setsearchdata}
      name="User Master"
    >
      {Loader && <LoadingSpinner />}
      <MessagePopup
        message={popup.message}
        severity={popup.severity}
        open={popup.open}
        setPopup={setPopup}
      />
      <ConfirmDialog
        open={dialogOpen}
        title={dialogData.title}
        content={dialogData.content}
        onClose={handleCloseDialog}
        onConfirm={dialogData.onConfirm}
      />
      <ExportDialog
        open={openExport}
        onClose={exportClose}
        setPopup={setPopup}
        data={exportData}
        fileName="Users"
      />
      <Box sx={{ display: "flex", justifyContent: "flex-end", width: "98%" }}>
        <AccessComponent name="User Master" action="Create">
          <MaterialButton
            variant="contained"
            onClick={() => {
              addRole();
            }}
            sx={{
              background: colors.buttonColor,
              color: "#fff",
              textTransform: "capitalize",
            }}
          >
            + Add User
          </MaterialButton>
        </AccessComponent>
        <Dialog
          open={open}
          sx={{
            "& .MuiDialog-paper": {
              width: "800px", // Set your desired width
              maxWidth: "none", // Prevent it from limiting the width to default sizes
            },
          }}
        >
          <AddUserMaster
            formClose={formClose}
            editeddata={editeddata}
            editedtrue={editedtrue}
            setEditedtrue={setEditedtrue}
            view={view}
          />
        </Dialog>
      </Box>
      <DynamicTableProps
        columns={columns}
        rows={exportData}
        onView={onView}
        onEdit={onEdit}
        onDelete={deletelist}
        name="User Master"
        serverPage={serverPage}
        totalCount={totalCount}
        onPageChange={(event, newPage) => setServerPage(newPage)}
      />
    </DashboardLayout>
  );
}

export default UserMaster;
